/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { array, func, number } from 'prop-types';
import { useSelector } from 'react-redux';
import style from './ProgressSteps.module.css';
import byoTheme from './BYOTheme';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const ProgressSteps = ({
    steps, prevStep, activeStep,
}) => {
    useStyles(style);
    const brandData = useSelector(getBrand);
    const brandCode = brandData?.code;

    // default color assigned when no brand code found
    const {
        filledColorBg = '#512C1C',
        unFilledColorBg = '#ffffff',
        borderFilledColor = '#512C1C',
        borderUnFilledColor = '#C8E9F1',
        labelFilledColor = '#000000',
        labelUnFilledColor = '#7B7B7B',
        countFilledColor = '#ffffff',
        countUnFilledColor = '#91674A',
        checkMarkFilledColor = '#ffffff',
        checkMarkBgColor = '#91674A',
    } = byoTheme[brandCode] || {};

    const totalSteps = steps.length;
    const width = `${(100 / (totalSteps - 1)) * (activeStep - 1)}%`;
    return (
        <div className={style.mainContainer} id="progressStep">
            <div
                className={style.stepContainer}
                style={{
                    '--width-step-container': width,
                    '--border-line-filled-color': borderFilledColor,
                    '--border-line-unfilled-color': borderUnFilledColor,
                }}
            >
                {steps.map(({ label }, index) => {
                    const stepIndex = index + 1;
                    return (
                        <div
                            className={style.stepWrapper}
                            style={{
                                '--bg-step-color': activeStep >= stepIndex ? filledColorBg : unFilledColorBg,
                                '--border-Circle-color': activeStep >= stepIndex ? borderFilledColor : borderUnFilledColor,
                                '--count-step-color': activeStep >= stepIndex ? countFilledColor : countUnFilledColor,
                                '--label-step-color': activeStep >= stepIndex ? labelFilledColor : labelUnFilledColor,
                                '--check-mark-bg': checkMarkBgColor,
                                '--check-mark-color': checkMarkFilledColor,
                            }}
                            key={stepIndex}
                            role="presentation"
                            onClick={() => activeStep > stepIndex && prevStep(stepIndex)}
                            data-testid="progress_step"
                        >
                            <div
                                className={style.stepStyle}
                            >
                                {activeStep > stepIndex ? (
                                    <div className={style.checkMark}>{stepIndex}</div>
                                ) : (
                                    <strong className={style.stepCount}>{stepIndex}</strong>
                                )}
                            </div>
                            <div className={`${style.stepsLabelContainer} ${activeStep > stepIndex ? style.stepLabelWrapper : ''}`}>
                                {activeStep !== stepIndex ?  <span className={style.stepLabel} key={stepIndex}>{label}</span> : <strong key={stepIndex} className={style.stepLabel}>{label}</strong> }
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

ProgressSteps.propTypes = {
    steps: array,
    prevStep: func,
    activeStep: number.isRequired,
};

ProgressSteps.defaultProps = {
    steps: [],
    prevStep: () => { },
};
export default ProgressSteps;
